import { blue, gray } from './foundation-colors.js';

const light = {
  'brand-background': gray[1],
  'brand-background-secondary': gray[3],
  'brand-text': gray[15],
  'brand-text-secondary': gray[13],
  'brand-icon-secondary': gray[12],
  'brand-link': blue[11],
  'brand-link-hover': blue[12],
  'brand-border': gray[8],
  'brand-border-secondary': gray[7],
};

const dark = {
  'brand-background': 'hsl(200, 8.0%, 12%)',
  'brand-background-secondary': 'hsl(200, 7.0%, 8.8%)',
  'brand-text': gray[8],
  'brand-text-secondary': gray[11],
  'brand-icon-secondary': gray[11],
  'brand-link': blue[11],
  'brand-link-hover': blue[12],
  'brand-border': gray[14],
  'brand-border-secondary': gray[14],
};

/**
 * Exported Commslayer semantic colors.
 */
export const semanticColors = {
  light,
  dark,
};
